module.exports = __webpack_public_path__ + "static/media/icon6.af63e731.svg";